import type { Organization } from '@hotjar/organization';
import type { User } from '@hotjar/user';
import { uniqBy } from 'lodash-es';

export function getUsersFromOrganizations(organizations: Organization[]): User[] {
  const users = organizations.flatMap((organization) => organization.users);
  return uniqBy(users, (user) => user.email);
}
